import { render, staticRenderFns } from "./editPreVenda.vue?vue&type=template&id=3c043aca"
import script from "./editPreVenda.ts?vue&type=script&lang=js&external"
export * from "./editPreVenda.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c043aca')) {
      api.createRecord('3c043aca', component.options)
    } else {
      api.reload('3c043aca', component.options)
    }
    module.hot.accept("./editPreVenda.vue?vue&type=template&id=3c043aca", function () {
      api.rerender('3c043aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/editPreVenda.vue"
export default component.exports